import { IIceCream } from '../interfaces/i-icecream'
import {
    Category,
    GuteSnurr,
    IceCreamMenu,
    Milkshake,
    GuteStruten
} from '../interfaces/IceCreamTypes'

export interface ICategory {
    title: Category
    description: string
    icon: string
    fromPrice: string
    items: IIceCream[]
}

export const categoryItems: ICategory[] = [
    {
        title: Category.SoftIceCream,
        description: 'Vår egen mjukglass på äkta ekologiska råvaror',
        icon: 'img/sketch-mjukglass.svg',
        fromPrice: 'fr. 45',
        items: [
            {
                category: Category.SoftIceCream,
                title: 'Ekologisk Mjukglass',
                description:
                    'Vår egen mjukglass på äkta ekologiska råvaror. Serveras i våffla eller bägare med valfri topping',
                img: 'img/softicecream.jpg',
                price: 45
            }
        ]
    },
    {
        title: Category.GuteSnurr,
        description:
            'Vår egen ekologiska mjukglass mixad med härliga tillbehör',
        icon: 'img/sketch-gutesnurr.svg',
        fromPrice: 'fr. 55',
        items: [
            {
                category: Category.GuteSnurr,
                title: 'Kolaknäck',
                description:
                    'Vår egen ekologiska mjukglass mixad med kolasås och vårt egna knäckiga och salta strössel',
                img: 'img/496512656_624554157331124_7917155822591264585_n.jpg',
                flavor: GuteSnurr.CaramelButterscotch,
                price: 55
            },
            {
                category: Category.GuteSnurr,
                title: 'Trippelchoklad',
                description:
                    'Vår egen ekologiska mjukglass mixad med chokladkolasås samt bitar av ekologisk vit choklad och mjölkchoklad från Malmö chokladfabrik',
                img: 'img/496513537_2961162300712014_7532177344196738955_n.jpg',
                flavor: GuteSnurr.Trippelchoklad,
                price: 55
            },
            {
                category: Category.GuteSnurr,
                title: 'Lemoncurd & maräng',
                description:
                    'Vår egen ekologiska mjukglass mixad med äkta engelsk lemoncurd och ekologiska maränger från hönseriet i Mjällby',
                img: 'img/494572298_743671668328202_7218420203630392151_n.jpg',
                flavor: GuteSnurr.Lemon,
                price: 55
            },
            {
                category: Category.GuteSnurr,
                title: 'Polka',
                description:
                    'Vår egen ekologiska mjukglass mixad med bitar av polkagris samt vår egen hallonsås',
                img: 'img/503032229_574657915376666_1894112829161892411_n.jpg',
                flavor: GuteSnurr.Polka,
                price: 55
            },
            {
                category: Category.GuteSnurr,
                title: 'Hallon & Lakrits',
                description:
                    'Vår egen ekologiska mjukglass mixad med hallonströssel och saltlakrits-kolasås',
                img: 'img/494573078_910938021172695_8714299200998590048_n.jpg',
                flavor: GuteSnurr.HallonLakrits,
                price: 55
            },
            {
                category: Category.GuteSnurr,
                title: 'Nougat',
                description:
                    'Vår egen ekologiska mjukglass mixad med kanderade hasselnötter och nougat kolasås',
                img: 'img/494577166_726714986550169_3865479527704697579_n.jpg',
                flavor: GuteSnurr.Nougat,
                price: 55
            },
            {
                category: Category.GuteSnurr,
                title: 'Gör din egen Gutesnurr',
                description:
                    'Välj fritt bland alla våra strössel och såser (max 4 tillbehör per bägare)',
                img: 'img/496509184_1038180651361485_7015868464227292860_n.jpg',
                flavor: GuteSnurr.Customized,
                price: 60
            }
        ]
    },
    {
        title: Category.Milkshake,
        description: 'Milkshake gjord på vår ekologiska mjukglass',
        icon: 'img/sketch-milkshake.svg',
        fromPrice: '75',
        items: [
            {
                category: Category.Milkshake,
                title: 'Dagens Milkshake',
                description: 'Fråga personalen om veckans smak',
                img: 'img/496513337_696499850020245_4599699239300325663_n.jpg',
                flavor: Milkshake.DagensMilkshake,
                price: 89
            }
        ]
    },
    {
        title: Category.GuteStruten,
        description:
            'Vår ekologiska kulglass doppad i 60% choklad och rullad i strössel',
        icon: 'img/sketch-milkshake.svg',
        fromPrice: '55',
        items: [
            {
                category: Category.GuteStruten,
                title: 'Honung & Saffran & Hallon',
                description:
                    'Våffla med 1 kula Honung & saffransglass doppad i choklad och hallonströssel',
                img: 'img/496512899_5077154045842015_2884264760153337654_n.jpg',
                flavor: GuteStruten.HonungSaffranHallon,
                price: 55
            },
            {
                category: Category.GuteStruten,
                title: 'Salt gräddkola & Popcorn',
                description:
                    'Våffla med 1 kula salt gräddkolaglass doppad i choklad och popcorn strössel',
                img: 'img/503104607_1827699024678232_7474149644029217540_n.jpg',
                flavor: GuteStruten.SaltKolaPopcorn,
                price: 55
            },
            {
                category: Category.GuteStruten,
                title: 'Choklad & Nötkrokant',
                description:
                    'Våffla med 1 kula chokladglass doppad i choklad och nötkrokant',
                img: 'img/494572422_688039764028221_3751930242918976953_n.jpg',
                flavor: GuteStruten.ChokladNutKrokant,
                price: 55
            }
        ]
    },
    {
        title: Category.IceCreamMenu,
        description: 'Olika glassmenyer på vår ekologiska glass',
        icon: 'img/sketch-milkshake.svg',
        fromPrice: '80',
        items: [
            {
                category: Category.IceCreamMenu,
                title: 'Klassisk marängsviss',
                description:
                    'Vår egen mjukglass, Gute Glass ekologisk choklad-glass, maränger, banan, chokladsås och grädde',
                img: 'img/IMG_4645.jpg',
                flavor: IceCreamMenu.Marangsviss,
                price: 95
            },
            {
                category: Category.IceCreamMenu,
                title: 'Bananhalve',
                description:
                    'Gute Glass choklad och jordgubbsglass med vår egen mjukglass på toppen, banan och chokladsås',
                img: 'img/IMG_4648.jpg',
                flavor: IceCreamMenu.Bananhalve,
                price: 95
            },
            {
                category: Category.IceCreamMenu,
                title: 'Gotländsk sommar',
                description:
                    'Gute Glass salmbärs- och honung & saffrans-glass toppad med salmbärssylt och vår egen mjukglass',
                img: 'img/IMG_4834.jpg',
                flavor: IceCreamMenu.GotlandskSommar,
                price: 95
            },
            {
                category: Category.IceCreamMenu,
                title: 'Gute brickan',
                description:
                    'En avsmakningsmeny med Gute glass-favoriter 3 smaker kulglass och 2 sorters mjukglass att dela på',
                img: 'img/IMG_4829.jpg',
                flavor: IceCreamMenu.GuteBrickan,
                price: 129
            }
        ]
    }
]
